import axios from "axios";

export const postInboxSendMessage = async (inboxConversationId: number, content: string) => {
  const response = await axios.post("/inbox/send-message", {
    inbox_conversation_id: inboxConversationId,
    content: content,
  });

  return response.data.data;
};

export const postInboxCreateConversation = async (
  typeId: number,
  content: string,
  allegroLogin: string,
  orderId: string,
  customerLogin: string
) => {
  const response = await axios.post("/inbox/create-conversation", {
    type_id: typeId,
    content,
    allegro_login: allegroLogin,
    order_id: orderId,
    customer_login: customerLogin,
  });

  return response.data.data;
};
